export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7648.d62faf4f.jpg";